import { withInstall } from '../../utils/install';
import Page from './index.vue';

export const IvuePage = withInstall(Page);
export default IvuePage;

export * from './index.vue';
